<div
  class="container-fluid d-flex text-light flex-nowrap flex-column justify-content-center align-items-center c-height 222"
  style="margin-top: 115px"
>
  <div class="custom-max-width">
    <div class="d-flex align-items-center flex-wrap">
      <h1 class="display-2 font-2_2rem" style="font-weight: 600">
        {{ "Knowledge gate" | translator }}
      </h1>
      <div
        *ngIf="currentOu"
        class="d-flex align-items-end custom-mx-3 bg-light px-4 py-2 rounded-5"
      >
        <span class="btn-flex">
          <img
            *ngIf="checkisImg(currentOu.image_sq); else elseBlock"
            src="{{ staticURL }}{{ currentOu.image_sq }}"
            class="img-fluid p-1"
            style="max-height: 30px; max-width: 50px"
          />
          <ng-template #elseBlock>
            <i class="{{ currentOu.image_sq }} p-2" style="font-size: 1rem"></i>
          </ng-template>
        </span>
        <p
          class="px-2 text-black-50"
          style="line-height: 0; padding-top: 0.5rem"
        >
          {{ currentOu.name }}
        </p>
      </div>
    </div>
    <div class="p-inputgroup my-3 pos-rel">
      <span class="pos-abs">
        <i
          *ngIf="!searchQueryObject"
          [routerLink]="'/home'"
          class="pi pi-fw pi-angle-right font-500 font-4"
        ></i>
        <i
          *ngIf="searchQueryObject"
          (click)="gotoAdvanceSearch(searchQueryObject)"
          class="pi pi-fw pi-angle-right font-500 font-4"
        ></i>
      </span>
      <span class="p-input-icon-right w-100">
        <i class="pi pi-search"></i>
        <input
          type="text"
          class="p-inputtext-lg sstarabic w-100 radius-8"
          pInputText
          placeholder="بحث"
          [(ngModel)]="searchText"
          maxlength="200"
          (keydown.enter)="navigateToSearch($event)"
        />
      </span>
    </div>
    <div class="d-flex">
      <!-- <span class="btn-flex">
                <span class="btn-css mx-2 font-0_8rem" [routerLink]="'/home'">رجوع</span>
                <span [routerLink]="'/home'" class="icon-box">
                    <i class="pi pi-fw pi-angle-right font-500"></i>
                </span>
            </span> -->
      <span class="btn-flex">
        <span
          class="btn-css mx-2 font-0_8rem"
          (click)="showItems = !showItems"
          >{{ "Recent searches" | translator }}</span
        >
        <span class="icon-box" (click)="showItems = !showItems">
          <i class="pi pi-fw font-500 pi-angle-down font-15"></i>
        </span>
      </span>
    </div>
    <div
      *ngIf="showItems && recentsearches.length > 0 && isLoggedIn"
      class="d-flex align-items-center w-100 ovr-flow-hide gap-2 my-2 m-bottom-4"
    >
      <p-chip
        class="pointer"
        *ngFor="let item of recentsearches"
        [label]="item?._id"
        (click)="
          searchText = item?._id;
          navigateToSearch({ target: { value: searchText } })
        "
        styleClass="px-3 white-space-nowrap text-dark text-nowrap"
      ></p-chip>
    </div>
  </div>
</div>
